import React from "react";
import { MdArrowBack, MdDelete, MdEdit, MdVpnKey } from "react-icons/md";
import Button from "../common/Button";

interface UserDetailHeaderProps {
  isMyProfile: boolean;
  onBack: () => void;
  onEdit: () => void;
  onChangePassword: () => void;
  onDelete: () => void;
}

const UserDetailHeader: React.FC<UserDetailHeaderProps> = ({
  isMyProfile,
  onBack,
  onEdit,
  onChangePassword,
  onDelete,
}) => (
  <div className="flex items-end justify-between">
    <button
      onClick={onBack}
      className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
    >
      <MdArrowBack className="h-6 w-6 md:mr-2 md:h-4 md:w-4" />
      <span className="hidden md:inline">Back to Users</span>
    </button>

    <div className="mt-3 flex flex-wrap justify-end gap-3">
      <Button onClick={onEdit}>
        <MdEdit className="mr-2 h-4 w-4" />
        {isMyProfile ? "Edit My Profile" : "Edit User"}
      </Button>
      <button
        onClick={onChangePassword}
        className="inline-flex items-center rounded-md bg-orange-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-orange-700"
      >
        <MdVpnKey className="mr-2 h-4 w-4" />
        {isMyProfile ? "Change My Password" : "Change Password"}
      </button>
      <button
        onClick={onDelete}
        className="inline-flex items-center rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700"
      >
        <MdDelete className="mr-2 h-4 w-4" />
        {isMyProfile ? "Delete My Profile" : "Delete User"}
      </button>
    </div>
  </div>
);

export default UserDetailHeader;
